
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import { Options, Vue, prop } from "vue-class-component";
import Checkbox from "primevue/checkbox";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  merchantData = prop<any>({
    default: {},
    type: Object
  });
  summaryData = prop<any>({
    default: {},
    type: Object
  });
  isLoading = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    ModalV3,
    Checkbox
  },
  emits: ["close", "confirm"]
})
export default class ModalUpdateOrder extends Vue.with(Props) {
  isDisabled = false;
  isCheck = false;
  close() {
    this.isCheck = false;
    this.$emit("close");
  }
  confirm() {
    this.isCheck = false;
    this.$emit("action");
  }
}
